import { RootAppState } from 'store/configureStore'

/** @deprecated Feature removed - statusChangeInPortalIsAllowedManuallySet no longer exists on ProjectRow */
export const projectStatusChangeInPortalAllowedManuallySetSelector = (
  _state: RootAppState,
) => {
  return undefined
}
